<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-crypto__token">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-select v-model="dataForm.pid" placeholder="所属区块链" clearable>
            <el-option
              v-for="item in chainList"
              :key="item.id"
              :label="item.chainName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.tokenCode" placeholder="请输入代币代码" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('crypto:token:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('crypto:token:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="tokenCode" label="代币代码" header-align="center" align="center" width="120"></el-table-column>
        <el-table-column prop="tokenName" label="代币名称" header-align="center" align="center" width="150"></el-table-column>
        <el-table-column prop="contractAddress" label="合约地址" :show-overflow-tooltip="true" header-align="center" align="center"></el-table-column>
        <el-table-column prop="walletAddress" label="收款钱包地址" :show-overflow-tooltip="true" header-align="center" align="center"></el-table-column>
        <el-table-column prop="decimals" label="精度" header-align="center" align="center" width="80"></el-table-column>
        <el-table-column prop="isNative" label="是否原生币" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isNative === 1" type="success">是</el-tag>
            <el-tag v-if="scope.row.isNative === 0" type="info">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isEnabled" label="启用状态" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isEnabled === 1" type="success">启用</el-tag>
            <el-tag v-else-if="scope.row.isEnabled === 2" type="danger">禁用</el-tag>
            <el-tag v-else-if="scope.row.isEnabled === 0" type="info">未知</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sortOrder" label="排序" header-align="center" align="center" width="80"></el-table-column>
        <el-table-column prop="orderExpireMinutes" label="订单超时(分钟)" header-align="center" align="center" width="120"></el-table-column>
        <el-table-column prop="ext1" label="回调API地址" :show-overflow-tooltip="true" header-align="center" align="center"></el-table-column>
        <el-table-column prop="ext2" label="请求方式" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            {{ getDictLabel(scope.row.ext2, requestTypeOptions) }}
          </template>
        </el-table-column>
        <el-table-column prop="ext3" label="Content-Type" :show-overflow-tooltip="true" header-align="center" align="center" width="200">
          <template slot-scope="scope">
            {{ getDictLabel(scope.row.ext3, contentTypeOptions) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('crypto:token:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('crypto:token:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './token-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/crypto/token/list',
        getDataListIsPage: true,
        deleteURL: '/crypto/token',
        deleteIsBatch: true
      },
      dataForm: {
        pid: '',
        tokenCode: ''
      },
      chainList: [],
      requestTypeOptions: [],
      contentTypeOptions: []
    }
  },
  components: {
    AddOrUpdate
  },
  created () {
    this.getChainList()
    this.getRequestTypeOptions()
    this.getContentTypeOptions()
  },
  methods: {
    // 获取区块链列表
    getChainList () {
      this.$http.get('/crypto/chain/enabled').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.chainList = res.data
      }).catch(() => {})
    },
    // 获取HTTP请求方式字典
    getRequestTypeOptions () {
      this.$http.get('/sys/dict/type/page', {
        params: { dictType: 'HTTP-request-type', page: 1, limit: 1 }
      }).then(({ data: res }) => {
        if (res.code === 0 && res.data && res.data.list && res.data.list.length > 0) {
          const typeId = res.data.list[0].id
          this.$http.get('/sys/dict/data/page', {
            params: { dictTypeId: typeId, page: 1, limit: 100, order: 'asc', orderField: 'sort' }
          }).then(({ data: dataRes }) => {
            if (dataRes.code === 0 && dataRes.data && dataRes.data.list) {
              this.requestTypeOptions = dataRes.data.list
            }
          }).catch(() => {})
        }
      }).catch(() => {})
    },
    // 获取Content-Type字典
    getContentTypeOptions () {
      this.$http.get('/sys/dict/type/page', {
        params: { dictType: 'Content-Type', page: 1, limit: 1 }
      }).then(({ data: res }) => {
        if (res.code === 0 && res.data && res.data.list && res.data.list.length > 0) {
          const typeId = res.data.list[0].id
          this.$http.get('/sys/dict/data/page', {
            params: { dictTypeId: typeId, page: 1, limit: 100, order: 'asc', orderField: 'sort' }
          }).then(({ data: dataRes }) => {
            if (dataRes.code === 0 && dataRes.data && dataRes.data.list) {
              this.contentTypeOptions = dataRes.data.list
            }
          }).catch(() => {})
        }
      }).catch(() => {})
    },
    // 根据字典值获取字典标签
    getDictLabel (value, options) {
      if (!value || !options || options.length === 0) {
        return ''
      }
      const item = options.find(opt => opt.dictValue === value)
      return item ? item.dictLabel : value
    }
  }
}
</script>
